import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ControlType, SimpleInputModule } from '@hglobal/common';
import { ShopOrder, FormType, InpostOrderForm } from '@pt/models';

@Component({
  selector: 'pt-delivery-inpost',
  templateUrl: './inpost.component.html',
  styleUrls: ['./inpost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    SimpleInputModule,
  ],
})
export class InpostComponent implements OnInit {
  readonly #formBuilder = inject(FormBuilder);

  order = input.required<ShopOrder>();
  form = input.required<FormType<InpostOrderForm, 'delivery'>>();

  readonly controlTypes = ControlType;

  ngOnInit(): void {
    this.form().removeControl('delivery');
    this.form().addControl(
      'delivery',
      this.#formBuilder.group({
        country: [this.order().location.country, Validators.required],
        city: ['', Validators.required],
        postOffice: '',
        postTerminal: '',
        email: ['', Validators.required],
      }),
    );
  }
}
